import { Component, OnInit, Input, Output, EventEmitter, HostBinding, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ClientNotification } from '../data/client-nfs';
import { ProjectWindowComponent } from 'projects/desktop/src/app/modules/project/view/project-window/project-window.component';
import { ProjectInfoComponent } from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import { MatDialog } from '@angular/material/dialog';
import { ClientSendEmailDialogComponent } from '../client-send-email-dialog/client-send-email-dialog.component';
import { ClientNotificationService } from '../data/client-nfs.service';
import moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';
import * as jq from 'jquery';
import { timer } from 'rxjs';

@Component({
    selector: 'app-client-message',
    templateUrl: './client-message.component.html',
    styleUrls: ['./client-message.component.scss']
})
export class ClientMessageComponent implements OnInit, AfterViewInit {

    @Input()
    clientNf: ClientNotification;

    dismissLoading: boolean;

    deleteLoading: boolean;

    @Input()
    isMobile: boolean;

    @Input()
    fromProj: boolean;

    @Output()
    dismissMsg = new EventEmitter<number>();

    @Output()
    deleteMsg = new EventEmitter<number>();

    overlayPanelMessage: string;

    @ViewChild('clientNfsOp', { static: true })
    clientNfsOp: OverlayPanel

    @ViewChild('infoIconHover', { static: false })
    infoIconHover: ElementRef

    constructor(
        protected dialog: MatDialog,
        protected el: ElementRef,
        protected clientNotificationService: ClientNotificationService,

    ) { }

    ngOnInit(): void {
        if (this.clientNf.resolvedTime && this.clientNf.sentBy) {
            this.overlayPanelMessage = `Sent By: ${this.clientNf.sentBy?.name},
		${moment(this.clientNf.resolvedTime).format('MMM D h:mm a')}`
        }
        else if (this.clientNf.dismissed) {
            this.overlayPanelMessage = `Dismissed By:
			${this.clientNf.dismissedBy?.name}, ${moment(this.clientNf.dismissed).format('MMM D h:mm a')}`
        }


    }

    ngAfterViewInit() {
        if (this.overlayPanelMessage) {
            const el = (this.el.nativeElement as HTMLElement).getElementsByClassName('hover-info-icon')[0]
            const shtEl = jq(el)
            // tslint:disable-next-line: deprecation
            shtEl.hover(jQEvent => {
                this.showHint(el)
            }, jQEvent => {
                this.hideHint()
            })
        }
    }

    showHint(el: Element) {
        this.clientNfsOp.show({}, el)
    }

    hideHint() {
        this.clientNfsOp.hide();
    }

    openProject(projectId: number) {
        if (!this.fromProj) {
            let projectWindow = ProjectWindowComponent as any;
            let panelClass = 'project-window-dialog';

            if (this.isMobile) {
                projectWindow = ProjectInfoComponent
                panelClass = 'project-info-dialog'
            }

            const dialogRef = this.dialog.open(projectWindow, {
                data: {
                    projectNumber: projectId
                },
                panelClass
            });

            dialogRef.afterClosed().subscribe(result => {
                this.clientNotificationService.getClientNf(this.clientNf.id).subscribe(clientnf => {
          this.clientNf = clientnf

          this.clientNf.project = {
            id: clientnf.projectId,
            name: clientnf.projectName
          }
        })
                // this.clientNf.resolvedTime = new Date();
            });
        }
    }

    sendEmail(clientNfs: ClientNotification) {
        let customerEmail = 'No E-Mail';
        let showSendButton = false;

        if (clientNfs.sentTo) {
            customerEmail = clientNfs.sentTo
            showSendButton = true;
        }

        const dialogRef = this.dialog.open(ClientSendEmailDialogComponent, {
            data: {
                clientNfs,
                dialogHeader: clientNfs.project ? clientNfs.project.name : clientNfs.projectName  + ' - ' + clientNfs.sentTo,
                showSendButton,
                resolved: clientNfs.resolvedTime
            },
            panelClass: 'client-nfs-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Success!') {
                this.clientNotificationService.getClientNf(this.clientNf.id).subscribe(newnf => {
                    this.clientNf = newnf

                    this.clientNf.resolvedTime = new Date();
                })
                // const index = this.clientNfs.indexOf(clientNfs, 0);
                // if (index > -1) {
                // 	this.clientNfs.splice(index, 1);
                // }
            }

        });
    }

    dismissEmail(clientNfs: ClientNotification) {
        if (!clientNfs.dismissed) {
            this.dismissLoading = true;

            this.clientNotificationService.dismissEmail(clientNfs.id).subscribe(newNfs => {
                this.dismissLoading = false;

                // this.dismissMsg.emit(clientNfs.id)

                this.clientNf.dismissed = new Date();
                this.clientNf.dismissedBy = newNfs.dismissedBy;
            })
        }
    }

    deleteNfs(clientNfs: ClientNotification) {
        this.deleteLoading = true;

        this.clientNotificationService.deleteNfs(clientNfs.id).subscribe(newNfs => {
            // this.deleteLoading = false;
            this.deleteMsg.emit(clientNfs.id)
        }, error => {
            this.deleteLoading = false;
        })
    }

}
